import moment from "moment";

// @vue/component
export default {
  name: "ConnectionsListSearchPanel",

  data() {
    return {
      dates: [
        moment()
          .subtract(1, "days")
          .format("YYYY-MM-DD 00:00:00"),
        moment().format("YYYY-MM-DD 23:59:59")
      ],
      searchParams: {
        client: [],
        project: [],
        agent: [],
        element_menu_name: [],
        number_a: null,
        number_b: null,
        effect: null,
        another_action: null,
        date_from: null,
        date_to: null,
        connection_id: "",
        groups: []
      },
      isSearchPanelVisible: true,
      rules: {
        number_a: [
          { min: 9, message: "Długość numeru musi mieć min. 9 znaków.", trigger: "blur" },
          { validator: this.__validateDigitsValues, trigger: "blur" }
        ],
        number_b: [
          { min: 9, message: "Długość numeru musi mieć min. 9 znakow", trigger: "blur" },
          { validator: this.__validateDigitsValues, trigger: "blur" }
        ],
        connection_id: [
          { message: "Nieprawidłowa wartość", trigger: "blur" },
          { validator: this.__validateConnectionId, trigger: "blur" }
        ],
        another_action: [
          { min: 4, message: "Długość danych musi mieć conajmniej 4 znaki", trigger: "blur" },
          { validator: this.__validateDigitsValues, trigger: "blur" }
        ]
      }
    };
  },

  computed: {
    connectionEffectsList() {
      return this.$store.getters["connections/effects/list"].records;
    },
    projectsList() {
      let projectsList = this.$store.getters["client/projects/list"].records;
      if (
        this.$store.getters["authorization/acl"].hasPermission(
          "projects_connection_list_display"
        ) &&
        !this.$store.getters["authorization/acl"].hasPermission("client_connection_list_display")
      ) {
        let agentProjects = this.agentsBelongsToUserlist.map(agent => agent.project_id);
        agentProjects = agentProjects.filter(
          (agent, index) => agentProjects.indexOf(agent) === index
        );
        projectsList = projectsList.filter(project => agentProjects.includes(project.id));
      }
      return projectsList;
    },
    agentsList() {
      return this.$store.getters["client/project/agents/list"].records;
    },
    agentsBelongsToUserlist() {
      return this.$store.getters["user/agent/agentsBelongsToUserlist"].records;
    },
    groupsBelongToUserList() {
      return this.$store.getters["client/groups/list"];
    },
    isLoadingEssentialList() {
      return this.$store.getters["global/pendingAsyncStoreActions"].includes([
        "client/projects/getList",
        "client/project/agents/getList"
      ]);
    },
    isLoadingConnectionEffectsList() {
      return this.$store.getters["global/pendingAsyncStoreActions"].includes([
        "connections/effects/getEffectList"
      ]);
    },
    menuElements() {
      const menuElements = this.$store.getters["client/project/alternativeMenu/list"].records;
      return menuElements.filter(el =>
        this.searchParams.project.length ? this.searchParams.project.includes(el.project_uuid) : el
      );
    },
    userHasAccessToAllConnectionsForClient() {
      return this.$store.getters["authorization/acl"].hasPermission(
        "client_connection_list_display"
      );
    },
    userHasAccessToAdditionalDataForConnection() {
      return this.$store.getters["authorization/acl"].hasPermission("another_action_access");
    },
    hasGroupsPermission() {
      return this.$store.getters["authorization/acl"].hasPermission("connection_list_groups");
    },
    pickerOptions() {
      let _this = this;
      return {
        disabledDate(date) {
          const pickedDate = moment(_this.minDate).valueOf();
          const threeMonthsBefore = moment(pickedDate)
            .subtract(90, "days")
            .valueOf();
          const todayMinusOneYear = moment()
            .add(1, "days")
            .subtract(365, "days")
            .valueOf();
          const threeMonthsLater = moment(pickedDate)
            .add(90, "days")
            .valueOf();
          const todayPlusEndDay = moment()
            .add(0, "days")
            .endOf("day")
            .valueOf();

          if (_this.minDate) {
            return (
              date.getTime() >= threeMonthsLater ||
              date.getTime() < threeMonthsBefore ||
              date.getTime() > todayPlusEndDay ||
              date.getTime() < todayMinusOneYear
            );
          }
          return date.getTime() > todayPlusEndDay || date.getTime() < todayMinusOneYear;
        },
        onPick({ minDate }) {
          if (!minDate && _this.minDate) {
            _this.minDate = null;
          } else if (minDate) {
            _this.minDate = minDate.getTime();
          }
        },
        firstDayOfWeek: 1
      };
    }
  },

  watch: {
    dates(newValue) {
      this.fillDateToSearchParams(newValue);
    },
    "searchParams.groups"(newValue, oldValue) {
      if (newValue.length < oldValue.length) {
        this.searchParams.agents = [];
      }
    }
  },

  async created() {
    this.getIsSearchPanelValueFromLocalStorage();
    this.fillDateToSearchParams(this.dates);
    await this.$store.dispatch("connections/effects/getEffectList");
    await this.$store.dispatch("client/groups/getGroupsList");
    this.$store.dispatch("connections/filterList", this.searchParams);
    this.$store.dispatch("client/project/alternativeMenu/getAllList");

    this.$EventBus.$on("ConnectionsListItem/FILTER_AT_SPECIFIC_VALUE", params => {
      if (!Object.keys(this.searchParams).includes(params.key)) return;
      this.searchParams[params.key] = params.value;
      this.$store.dispatch("connections/filterList", this.searchParams);
    });
  },

  beforeDestroy() {
    this.$EventBus.$off("ConnectionsListItem/FILTER_AT_SPECIFIC_VALUE");
  },

  methods: {
    __validateDigitsValues(rule, value, callback) {
      if (!value) callback();
      if (!/^\d+$/.test(value)) callback(new Error("Nieprawidłowa wartość"));
      callback();
    },
    __validateConnectionId(rule, value, callback) {
      if (!value) callback();
      if (!/^\d+(,\s?\d+)*$/.test(value)) callback(new Error("Nieprawidłowa wartość"));
      callback();
    },
    __updatedSelectedAgents() {
      this.searchParams.agent = this.agentsList
        .filter(agent => this.searchParams.agent.includes(agent.uuid))
        .filter(agent => this.searchParams.project.includes(agent.project_uuid))
        .map(agent => agent.uuid);
    },
    handleSelectProject(selectedProjects) {
      this.searchParams.project = selectedProjects;

      if (this.userHasAccessToAllConnectionsForClient) {
        if (selectedProjects.length !== 0)
          this.$store.dispatch("client/project/agents/getList", this.searchParams.project);

        this.__updatedSelectedAgents();
      }
    },
    handleSelectGroup(selectedGroups) {
      if (this.hasGroupsPermission) {
        if (selectedGroups.length !== 0)
          this.$store.dispatch("client/project/agents/getListByGroups", this.searchParams.groups);

        this.__updatedSelectedAgents();
      }
    },
    submitSearchForm() {
      this.$emit("resetCurrentPage");
      this.$refs.searchForm.validate(async valid => {
        if (valid) await this.$store.dispatch("connections/filterList", this.searchParams);
        return false;
      });
    },
    resetForm(formName) {
      this.$emit("resetCurrentPage");
      this.$refs[formName].resetFields();
      this.$store.dispatch("connections/filterList", this.searchParams);
    },
    fillDateToSearchParams(date) {
      if (date) {
        const [dateFrom, dateTo] = date;
        this.searchParams.date_from = dateFrom;
        this.searchParams.date_to = `${dateTo}`;
      } else {
        this.searchParams.date_from = null;
        this.searchParams.date_to = null;
      }
    },
    toggleSearchBarVisibility() {
      this.isSearchPanelVisible = !this.isSearchPanelVisible;
      localStorage.setItem("isSearchPanelVisible", JSON.stringify(this.isSearchPanelVisible));
    },

    getIsSearchPanelValueFromLocalStorage() {
      const itemStr = localStorage.getItem("isSearchPanelVisible");
      if (!itemStr) {
        return null;
      }
      const item = JSON.parse(itemStr);
      this.isSearchPanelVisible = item;
    }
  }
};
